import _ from 'lodash';
import {ADD_DESKTOP_ELEMENT, DUPLICATE_DESKTOP_ELEMENT, PASTE_ELEMENTS} from '../element/actions/desktopElementActions';
import {UPDATE_ELEMENT_POSITION_BY_DELTA, UPDATE_ELEMENT_POSITION} from '../element/actions/elementLayoutActions';
import {UNDO_ACTION_ELEMENT, REDO_ACTION_ELEMENT, REPLACE_STORE} from '../element/actions/generalActions';
import {
  SET_MOUSE_START_POSITION,
  SET_SELECTED_ELEMENT_ID,
  CLEAR_SELECTED_ELEMENT_ID,
  TOGGLE_SELECTED_ELEMENT_ID,
  CLEAR_STATE,
  SET_EDITING_ELEMENT_ID,
  SET_IS_DRAGGING_ELEMENT,
  SET_DRAGGING_DIRECTION,
  SET_HOVERED_ELEMENT_ID,
  SET_MOUSE_DRAG_START_POSITION
} from 'crazyEditor/redux/modules/stage/stage';
import update from 'react-addons-update';
import {isChildElementId} from 'crazyEditor/core/elements/utils/elementFilterUtils';
import {hasElementPanel} from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import {PAGE_ELEMENT_ID} from 'crazyEditor/core/elements/utils/elementStaticUtils';
import {getViewState} from '../element/helpers/elementViewHelpers';

function shouldAnimateAddedElement(action) {
  if (!action.elementPosition || hasElementPanel(action.elementType)) {
    return true;
  }
  return false;
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case ADD_DESKTOP_ELEMENT:
    case DUPLICATE_DESKTOP_ELEMENT:
    case PASTE_ELEMENTS:
      const viewState = getViewState();
      const newElementIds = [];
      const existingElements = _.last(state.element.past)[viewState].elements;
      _.forEach(state.element.present[viewState].elements, (element, elementId) => {
        if (_.isNil(existingElements[elementId]) && !isChildElementId(elementId)) {
          newElementIds.push(elementId);
        }
      });
      let stateUpdate;
      if (!_.isEmpty(newElementIds)) {
        stateUpdate = {
          stage: {
            selectedElementIds: {
              $set: newElementIds,
            },
            editingElementId: {
              $set: null,
            },
          }
        };
      }
      if (shouldAnimateAddedElement(action)) {
        stateUpdate.stage.lastAddedElementsIds = {$set: newElementIds};
      }
      return update(state, stateUpdate);
    case SET_HOVERED_ELEMENT_ID:
    case SET_SELECTED_ELEMENT_ID:
    case CLEAR_SELECTED_ELEMENT_ID:
    case TOGGLE_SELECTED_ELEMENT_ID:
    case CLEAR_STATE:
    case SET_EDITING_ELEMENT_ID:
    case SET_IS_DRAGGING_ELEMENT:
    case SET_DRAGGING_DIRECTION:
    case SET_MOUSE_START_POSITION:
    case UPDATE_ELEMENT_POSITION:
    case UPDATE_ELEMENT_POSITION_BY_DELTA:
    case SET_MOUSE_DRAG_START_POSITION:
      if (state.stage.lastAddedElementsIds) {
        return update(state, {
          stage: {
            lastAddedElementsIds: {
              $set: null,
            }
          }
        });
      }
      break;
    case UNDO_ACTION_ELEMENT:
    case REDO_ACTION_ELEMENT:
      const listingDataUpdate = {};
      if (!_.isEmpty(state.listingData)) { // apply undo/redo to listing title or description
        _.forEach(state.element.present.desktop.elements, element => {
          const {data: {templateTag}} = element;
          if (templateTag && state.listingData[templateTag]) {
            listingDataUpdate[element.data.templateTag] = {
              $set: element.data.text,
            };
          }
        });
      }
      const newSelectedElementIds = [];
      _.forEach(state.stage.selectedElementIds, id => {
        if (state.element.present.desktop.elements[id] || state.element.present.desktop.staticElements[id] || state.element.present.mobile.elements[id] || state.element.present.mobile.staticElements[id]) {
          newSelectedElementIds.push(id);
        }
        if (_.isEmpty(newSelectedElementIds)) {
          newSelectedElementIds.push(PAGE_ELEMENT_ID);
        }
      });
      return update(state, {
        stage: {
          selectedElementIds: {
            $set: newSelectedElementIds
          }
        },
        listingData: listingDataUpdate,
      });
    case REPLACE_STORE:
      const elementsUpdate = {};
      if (!_.isEmpty(action.newState.listingData)) { // synchronize elements data with listing data
        _.forEach(action.newState.element.present.desktop.elements, element => {
          const {data: {templateTag}} = element;
          const listingDataValue = action.newState.listingData[templateTag];
          if (templateTag && listingDataValue) {
            elementsUpdate[element.id] = { data: { text: {$set: listingDataValue}}};
          }
        });
      }
      const newStateUpdate = {element: { present: { desktop: {elements: elementsUpdate}}}};
      return {
        ...state,
        ...update(action.newState, newStateUpdate),
      };
    default:
      break;
  }
  return state;
}
